import * as Handlebars from 'handlebars/runtime'
module.exports = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"chart-container\"></div>\n\n<div class=\"legend center horizontal\"></div>\n";
},"useData":true})